module.exports = __webpack_public_path__ + "static/media/fist-brown.dc40362d.png";